import type { TeamMemberView } from '../types';

interface Props {
  member: TeamMemberView | null;
  size?: number;
  title?: string;
}

function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0][0].toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export function AssigneeAvatar({ member, size = 22, title }: Props) {
  const name = member?.displayName ?? '?';
  const bg = member?.color ?? '#64748b';
  return (
    <span
      className="assignee-avatar"
      style={{
        width: size,
        height: size,
        backgroundColor: bg,
        fontSize: Math.max(10, size * 0.46),
      }}
      title={title ?? name}
      aria-label={`Assigned to ${name}`}
    >
      {initials(name)}
    </span>
  );
}
